/**************************************************
 * Nombre:       Home_Trabaja
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import TituloApartados from "./SubComponentes/TituloApartados";
import fondo from '../../../Recursos/home_trabaja.webp'
import fondo_pantalla from '../../../Recursos/fondo_pasos.svg'
import Boton from "./SubComponentes/Boton";
import Tarjeta_Pasos from "../../Tarjetas/Tarjeta_Pasos";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {useIrRuta} from "../../../Utilidades/useIrRuta";

const Home_Trabaja = () => {
    const {sCell} = useResponsive()
    const {Aviso, abrirAviso} = useIrRuta()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundImage: `url(${fondo_pantalla})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
            }}
        >
            <Aviso/>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3,}}
            >

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 11}}>


                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <TituloApartados titulo={'Como'} inicio={'COMO TRABAJAMOS'} negrita={'Creencia Central'}
                                         postitulo={'Trabaja'}
                                         frase={'Profesionales certificados para cada etapa de la vida'}/>
                    </Grid>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={10}

                    >

                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start', mt: 12}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                sx={{
                                    backgroundImage: `url(${fondo})`,
                                    backgroundRepeat: 'no-repeat',
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center center',
                                    p: 4,
                                    borderRadius: 6
                                }}
                                spacing={0}

                            >

                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 7}}
                                    sx={{
                                        backgroundColor: '#ffffff60',
                                        backdropFilter: 'blur(5px)',
                                        borderRadius: 6,
                                        color: '#fff',
                                        px: 3,
                                        py: 4,
                                        mb: sCell ? 0 : 46
                                    }}
                                >

                                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                        <Typography sx={{fontSize: 24, fontWeight: 800}}>
                                            Deseas Iniciar Ahora?
                                        </Typography>
                                    </Grid>

                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{justifyContent: 'flex-start', mt: 2}}>
                                        <Typography sx={{fontSize: 16, fontWeight: 600}}>
                                            Escoge el servicio que mas se ajuste segun tu criterio
                                        </Typography>
                                    </Grid>

                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{justifyContent: 'flex-start', mt: 2}}>
                                        <Boton click={() => abrirAviso('Aun no hay citas disponibles')} texto={'Agendar Ahora'} color={'secondary'}/>
                                    </Grid>


                                </Grid>


                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start', mt: sCell ? 0 : 12}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={5}
                            >

                                {pasos.map((item, index) => (
                                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                        <Tarjeta_Pasos item={item} index={index}/>
                                    </Grid>
                                ))}


                            </Grid>
                        </Grid>

                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt:  sCell ? 8 :12}}>
                        <Boton click={() => abrirAviso('Citas aun no disponilbes')} texto={'Empieza tu terapia ahora'}/>
                    </Grid>


                </Grid>
            </Grid>

        </Grid>
    )

}
export default Home_Trabaja

const pasos = [
    {
        nombre: 'Conecta con el experto',
        descripcion: 'Explora nuestra agenda y selecciona la charla del profesional de la salud que más te interese',
    },
    {
        nombre: 'Aprende en vivo',
        descripcion: 'Accede a la sesión online para recibir información actualizada y resolver tus dudas',
    },
    {
        nombre: 'Apoya el conocimiento',
        descripcion: 'Si la charla te aportó valor, realiza una donación voluntaria para impulsar la labor del profesional',
    },
]